import React from 'react';
import { Chip } from '@mui/material';

const styled = { border: 'none', fontWeight: 'bold' };

export default function ChipStatus({ children, style = styled }) {
  return <Chip avatar={children[0]} label={children[1]} variant="outlined" style={style} />;
}
